<template>
  <v-navigation-drawer
    id="app-drawer"
    :class="{ mini }"
    v-model="inputValue"
    app
    dark
    floating
    :mini-variant="mini"
    mobile-breakpoint="0"
    persistent
    touchless
    width="200"
  >
    <v-list-item class="logo" two-line>
      <v-icon class="menu-icon" @click.stop="mini = !mini">menu</v-icon>
      <v-list-item-avatar
        v-if="!$store.state.app.title"
        class="my-0"
        height="2.5rem"
        width="unset"
        rounded="0"
      >
        <svg width="82" height="24" viewBox="0 0 82 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M73.1195 15.9326H78.9619L80.37 19.9434H74.511L73.1195 15.9326ZM67.7789 4.03775H74.2523L78.1526 14.0036H63.8464L67.7789 4.03775ZM29.9981 19.9434H21.6635V15.7794H29.5288C30.5435 15.7086 31.4887 15.2657 32.1629 14.545C32.8372 13.8243 33.187 12.8829 33.1378 11.9216C33.182 11.4226 33.1106 10.9204 32.9286 10.45C32.7466 9.97974 32.4584 9.55263 32.084 9.19849C31.7096 8.84435 31.2581 8.57174 30.7608 8.39954C30.2637 8.22738 29.7328 8.15988 29.2051 8.20167H26.6966V14.0036H21.6635V4.03775H29.0433C33.7043 4.03775 38.3166 6.08907 38.3166 12.0595C38.3341 13.098 38.1309 14.1294 37.7192 15.0923C37.3076 16.0553 36.6958 16.9303 35.9201 17.6655C35.1444 18.4007 34.2205 18.9812 33.2033 19.3724C32.1861 19.7637 31.0962 19.9579 29.9981 19.9434ZM12.3474 15.9326H18.1735L19.5654 19.9434H13.8201L12.3474 15.9326ZM7.00675 4.03775H13.4803L17.3967 14.0036H3.07406L7.00675 4.03775ZM6.68301 19.9434H0.873047L2.26487 15.9326H8.07483L6.68301 19.9434ZM68.8634 15.9326L67.4553 19.9434H61.6451L63.0371 15.9326H68.8634Z" fill="white"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M50.7682 19.9626L44.3932 4.03775H39.4434L45.8184 19.9626H50.7682Z" fill="#E41313"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M63.5184 4.03775H59.0562L55.8808 12.4685L58.0745 17.6207L63.5184 4.03775ZM57.1435 19.9626L54.9119 14.389L50.7681 4.03775H46.3059L52.6808 19.9626H57.1435Z" fill="#E41313"/>
        </svg>
      </v-list-item-avatar>

      <v-list-item-title class="title">
        {{ $store.state.app.title || 'CRM' }}
      </v-list-item-title>


    </v-list-item>

    <v-list
      id="adv-main-menu"
      class="px-0"
      nav
    >

      <template v-for="menuItem in links">
        <template v-if="menuItem.children">
          <v-menu
            v-if="mini"
            offset-x
            content-class="drawer-sub-nav-menu"
            nudge-bottom="1"
            nudge-right="1"
            open-on-hover
            close-delay="100"
          >
            <template #activator="{on, value}">
              <v-list-group
                v-on="on"
                :class="{expanded: value}"
                no-action
                :value="getIsParentItemActive(menuItem.children)"
              >
                <template #activator>
                  <v-list-item-action class="my-0">
                    <v-icon dense>{{ menuItem.icon }}</v-icon>
                  </v-list-item-action>
                </template>
              </v-list-group>
            </template>

            <v-list class="drawer-sub-nav-menu-list" v-if="mini">
              <v-list-item
                v-for="childItem in menuItem.children"
                class="pl-5 py-3"
                :key="childItem.text"
                :to="childItem.to"
              >
                <v-list-item-action class="my-0">
                  <v-icon small>{{ childItem.icon }}</v-icon>
                </v-list-item-action>

                <v-list-item-title
                  v-text="childItem.text"
                />
              </v-list-item>
            </v-list>
          </v-menu>

          <v-list-group
            v-else
            no-action
            :value="getIsParentItemActive(menuItem.children)"
            @click="onGroupClick"
          >
            <template #activator>
              <v-list-item-action class="my-0">
                <v-icon dense>{{ menuItem.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-title v-text="menuItem.text" />
            </template>
            <v-list-item
              v-for="childItem in menuItem.children"
              class="pl-5"
              :key="childItem.text"
              :to="childItem.to"
            >
              <v-list-item-action class="my-0">
                <v-icon small>{{ childItem.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-title
                v-text="childItem.text"
              />
            </v-list-item>
          </v-list-group>
        </template>
        <v-list-item
          v-else
          :key="'item' + menuItem.text"
          :to="menuItem.to"
        >
          <v-list-item-action v-if="!mini" class="my-0">
            <v-icon dense>{{ menuItem.icon }}</v-icon>
          </v-list-item-action>
          <v-tooltip v-else right>
            <template #activator="{ on }">
              <v-list-item-action class="my-0" v-on="on">
                <v-icon dense>{{ menuItem.icon }}</v-icon>
              </v-list-item-action>
            </template>
            <span>{{ menuItem.text }}</span>
          </v-tooltip>

          <v-list-item-title>
            {{ menuItem.text }}
          </v-list-item-title>
        </v-list-item>
      </template>
    </v-list>

    <template #append>
      <v-list
        class="px-0"
        nav
      >
        <v-list-item @click="$emit('open-notifications')">
          <v-list-item-action>
            <v-badge
              :value="nUnreadNotifications > 0"
              :content="nUnreadNotifications"
              overlap
            >
              <v-icon dense>
                mdi-bell
              </v-icon>
            </v-badge>
          </v-list-item-action>
          <v-list-item-title>
            Notifications
          </v-list-item-title>
        </v-list-item>
        <v-list-item
          to="/two-fa"
        >
          <v-list-item-action class="mt-2 mb-2">
            <v-icon dense>{{ ($store.state.auth.user || {}).twofa_active ? 'mdi-lock' : 'mdi-lock-open-variant' }}</v-icon>
          </v-list-item-action>

          <v-list-item-title class="font-weight-light">
            Two FA
          </v-list-item-title>
        </v-list-item>
        <v-list-item
          to="/logout.json"
        >
          <v-list-item-action class="mt-2 mb-2">
            <v-icon dense>logout</v-icon>
          </v-list-item-action>

          <v-list-item-title class="font-weight-light">
            Logout
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </template>

  </v-navigation-drawer>
</template>

<style lang="scss">
.drawer-sub-nav-menu {
  border-radius: 0;
  &-list {
    padding: 0;
    background-color: #545763 !important;
    .v-list-item {
      color: #d0d3db !important;
      min-height: unset;
      gap: 0.25rem;

      &__action {
        .v-icon {
          color: #d0d3db;
        }
        min-width: unset;
        margin-right: 0 !important;
      }

      &__title {
        font-size: 0.75rem !important;
      }

      &--active {
        background-color: #545763;
      }
    }
  }
}
</style>

<style lang="scss">
#app-drawer {
  --adwa-title: white;
  --adwa-brand: #E41313;
  background-color: #282B33;

  &.mini {
    width: 56px !important;
  }


  .menu-icon {
    color: var(--adwa-brand);
  }

  .title {
    color: var(--adwa-title);
    font-weight: 400 !important;
    font-size: 1.175rem !important;
    flex-shrink: 2;
  }

  .v-list-group--active {
    .v-list-group__items {
      background-color: #383943 !important;
    }
  }

  .v-list-item {
    gap: 0.25rem;
    margin-bottom: 0;
    height: 2.5rem;
    min-height: unset;
    color: #D0D3DB;
    padding: 0.75rem 1rem;

    &.logo {
      margin-top: 7px !important;
      padding-left: 1rem;
      padding-right: 0;
    }

    &::before {
      border-radius: 0;
    }

    &__title {
      font-size: 0.875rem;
      font-weight: 300;
    }

    &__action {
      min-width: unset;
      margin-right: 0;
    }

    &--active {
      background-color: #545763;
    }

    &--active {
      border-radius: 0;
      &::before {
        content: none;
      }
    }

    &__icon {
      min-width: unset;
    }
  }

  .v-list-group {
    margin-bottom: 1px;
    border-top: 1px solid #353842;

    .v-list-item {
      border-radius: 0;
    }

    &:last-child {
      border-bottom: 1px solid #353842;
    }

    &__header__append-icon {
      margin-left: 0;
    }

    &.expanded {
      > .v-list-item {
        background-color: #545763;
      }
    }
  }

  .v-navigation-drawer__content {
    &::-webkit-scrollbar {
      width: 0.25rem;
    }

    &::-webkit-scrollbar-track {
      background-color: #1c1f28;
      border-radius: 0;
    }

    &::-webkit-scrollbar-thumb {
      background-image: none;
      background-color: #626571;
      border-radius: 0.125rem;
    }
  }
}
</style>

<script>
  // Utilities
  import {
    mapMutations,
    mapState
  } from 'vuex'

  import { find, get, trim } from 'lodash'

  const MINI_THRESHOLD = 1450;

  export default {
    props: {
      opened: {
        type: Boolean,
        default: false
      },
      nUnreadNotifications: {
        type: Number,
        required: true,
      },
    },
    data: () => ({
      mini: false,
      baseMap: {
        default: [
          {
              to: '/',
              icon: 'mdi-chart-bar',
              text: 'Dashboard',
          },
          {
              to: '/user-management',
              icon: 'mdi-account-multiple-outline',
              text: 'User management',
          },
          {
              to: '/blacklist',
              icon: 'mdi-list-status',
              text: 'Black list',
          },
          {
              to: '/tasks',
              icon: 'mdi-checkbox-marked-circle-plus-outline',
              text: 'Tasks',
          },
          {
              to: '/reports',
              icon: 'mdi-text-box-outline',
              text: 'Reports',
          },
          {
              to: '/payment-handler',
              icon: 'mdi-wallet-outline',
              text: 'Payment Handler',
          },
          {
            to: '/mirrors-redirectors',
            icon: 'mdi-arrow-decision',
            text: 'Mirrors, Redirectors',
          },
          {
            to: '/feature-config',
            icon: 'mdi-cog-outline',
            text: 'Feature Configs',
          },
          {
              to: '/kyc',
              icon: 'mdi-badge-account-horizontal-outline',
              text: 'KYC',
          },
          {
              to: '/daily-report',
              icon: 'mdi-chart-areaspline',
              text: 'Daily Report',
          },
          {
            to: '/postbacks',
            icon: 'mdi-cube-send',
            text: 'Postbacks',
          },
          {
            to: '/commissions',
            icon: 'mdi-sack-percent',
            text: 'Commissions',
          },
          {
            to: '/affiliate_statistic',
            icon: 'mdi-chart-bar-stacked',
            text: 'Affiliate Stats',
          },
          {
            to: '/vip_statistic',
            icon: 'mdi-crown',
            text: 'VIP',
          },
          {
            to: '/proxers',
            icon: 'mdi-arrow-decision',
            text: 'Proxers',
          },
          {
              to: '/tournaments',
              icon: 'mdi-star-four-points-circle-outline',
              text: 'Tournaments'
          },
          {
              to: '/jackpots',
              icon: 'mdi-slot-machine',
              text: 'Jackpots'
          },
          {
              icon: 'mdi-marker-check',
              text: 'Bonus set up',
              children: [
                  {
                      to: '/bonus-tools',
                      icon: 'mdi-trophy-variant-outline',
                      text: 'Bonus tools',
                  },
                  {
                      to: '/sport-bonus',
                      icon: 'mdi-basketball',
                      text: 'Sport bonus',
                  },
                  {
                      to: '/bonus-template',
                      icon: 'mdi-puzzle-outline',
                      text: 'Bonus template',
                  },
                  {
                      to: '/autobonus',
                      icon: 'mdi-robot-outline',
                      text: 'Autobonus',
                  },
                  {
                      to: '/games',
                      icon: 'mdi-cards-playing-outline',
                      text: 'Games',
                  },
              ]
          },
          {
              icon: 'mdi-bell-ring-outline',
              text: 'Communications',
              children: [
                  {
                    to: '/notification-center',
                    icon: 'circle_notifications',
                    text: 'Notifications center',
                  },
                  {
                    to: '/mail-template',
                    icon: 'mdi-email-multiple-outline',
                    text: 'Mail template',
                  },
              ]
          },
          {
              icon: 'donut_small',
              text: 'BI',
              children: [
                  {
                    to: '/business-intelligence',
                    icon: 'mdi-finance',
                    text: 'Brand statistics'
                  },
                  {
                    to: '/retention',
                    icon: 'mdi-poll',
                    text: 'Retention'
                  },
              ]
          },
          {
              icon: 'mdi-cog-outline',
              text: 'Settings',
              children: [
                  {
                    to: '/settings',
                    icon: 'mdi-tune-vertical',
                    text: 'System settings',
                  },
                  {
                    to: '/tools',
                    icon: 'mdi-tools',
                    text: 'Tools',
                  },
                  {
                    to: '/currency-rate',
                    icon: 'mdi-cash',
                    text: 'Currency',
                  },
                  {
                    to: '/cms-deploy',
                    icon: 'mdi-cube-outline',
                    text: 'CMS Deploy',
                  },
                  {
                    to: '/operators',
                    icon: 'mdi-face-agent',
                    text: 'Operators',
                  }
              ]
          },
          {
            to: '/suspicious-activity-review',
            icon: 'mdi-shield-alert-outline',
            text: 'Suspicious Accounts',
          }
        ],
        kiosk: [
          {
            to: '/kiosk/dashboard',
            icon: 'mdi-view-dashboard-variant',
            text: 'Dashboard',
          },
          {
            to: '/kiosk/entities',
            icon: 'mdi-file-tree-outline',
            text: 'Kiosk',
          },
          {
            to: '/kiosk/pin',
            icon: 'mdi-counter',
            text: 'Pin',
          },
          {
            to: '/kiosk/reports',
            icon: 'show_chart',
            text: 'Reports',
          },
          {
            to: '/kiosk/account_registration',
            icon: 'mdi-account-plus',
            text: 'Registration',
          },
          {
            to: '/kiosk/operators',
            icon: 'mdi-account-group',
            text: 'Operators',
          },
          {
            to: '/kiosk/account-list',
            icon: 'mdi-account-search',
            text: 'Accounts',
          },
        ]
      },
    }),

    created () {
      this.mini = window.innerWidth < MINI_THRESHOLD
      this.loadCmsTypes()
    },

    watch: {
      '$store.state.auth.auth' (val) {
        if (val) {
          this.loadCmsTypes()
        }
      },
    },

    computed: {
      ...mapState('app', [ 'panel' ]),
      inputValue: {
        get () {
          return this.$store.state.app.drawer
        },
        set (val) {
          this.setDrawer(val)
        }
      },

      cmsMenuChildren () {
        const children = [
          { to: '/cms/schemas', icon: 'mdi-cog-outline', text: 'Type Schemas' },
          { to: '/cms/media', icon: 'mdi-image-multiple-outline', text: 'Media' },
          { to: '/cms/deploy', icon: 'mdi-rocket-launch-outline', text: 'Deploy' },
          { to: '/cms/deployed', icon: 'mdi-database-eye-outline', text: 'Deployed Content' },
          { to: '/cms/bulk-action', icon: 'mdi-select-group', text: 'Bulk Action' },
        ]

        for (const type of this.$store.state.cms.main.types) {
          if (type.kind === 'fragment') {
            continue
          }
          children.push({
            to: '/cms/type/' + type.slug,
            icon: 'mdi-file-document-outline',
            text: type.name,
          })
        }

        return children
      },

      links () {
        if (this.panel === 'cms') {
          return this.cmsMenuChildren
        }

        let out = []
        for (let m of this.baseMap[this.panel] || []) {
          // { path: m.to }
          if (m.children) {
            const availableEndpoints = m.children.filter(({to}) => this.validateRoute(to))

            if (availableEndpoints.length > 0) {
              out.push({
                ...m,
                children: availableEndpoints
              })
            }

            continue
          }

          if (this.validateRoute(m.to)) {
            out.push(m)
          }
        }

        return out
      }
    },

    methods: {
      ...mapMutations('app', [ 'setDrawer' ]),
      validateRoute(to) {
        const route = find(this.$router.options.routes, (o) => to.length > 1 ? !!o?.path?.match(new RegExp('^\/' + trim(to, '/') + '(\/:.*\?){0,}', 'g')) : to === o?.path)

        return !route || this.$store.state.auth.checkAccess(get(route, 'meta.access', {}));
      },
      getIsParentItemActive(children) {
        const path = this.$route.path
        return children.some(child => path === child.to || path.startsWith(child.to + '/'))
      },
      onGroupClick() {
        setTimeout(() => {
          const menu = document.querySelector('#app-drawer .v-navigation-drawer__content')
          if (menu.scrollHeight > menu.clientHeight) {
            const openGroup = menu.querySelector('.v-list-group--active')

            if (openGroup) {
              openGroup.scrollIntoView({ behavior: 'smooth' })
            }
          }
        }, 100)
      },
      loadCmsTypes() {
        if (this.$store.state.auth.auth && this.$store.state.auth.checkAccess({ key: 'cms', value: true })) {
          this.$store.dispatch('cms/main/loadTypes')
        }
      },
    }
  }
</script>
